import React from 'react';
import { useEffect } from 'react';
import { useState } from 'react';
import axios from 'axios';
import DisplayCard from './DisplayCard';
import { appUrl } from '../../../../../../utils/config';

const Block = (props) => {
  const { statusID, statusText } = props?.data || {};
  const {
    status,
    handleQuickStatus,
    loading,
    count,
    lableText,
    nonClickable,
  } = props;

  // const [count, setCount] = useState(null);
  // const [loading, setLoading] = useState(true);
  const [selected, setSelected] = useState(false);

  useEffect(() => {
    if (statusID) {
      let quickStatus = statusID;
    if (status !== quickStatus) {
      setSelected(false);
    } else {
      setSelected(true);
    }
    }
  }, [status, statusID]);

  const handleClick = () => {
    setSelected(true);
    handleQuickStatus(statusID);
  };

  return (
    <DisplayCard
      tertiaryText={null}
      secondaryText={statusText ? statusText: lableText}
      primaryText={count}
      loading={loading}
      selected={selected}
      handleClick={nonClickable ? null : handleClick}
    />
  );
};

export default Block;
